import React from 'react';

import DistributionAmount from '../../Sell/SellFundEditor/DistributionAmount';

const CollegeDistributeFundEditor = (props) => {
  const {
    actions,
    deliveryMethod,
    fund,
    marketVolatility,
    personalData,
    transactionLimit,
    userAddress,
  } = props;
  return (
    <DistributionAmount
      actions={actions}
      deliveryMethod={deliveryMethod}
      fund={fund}
      marketVolatility={marketVolatility}
      personalData={personalData}
      transactionLimit={transactionLimit}
      userAddress={userAddress}
    />
  );
};

export default CollegeDistributeFundEditor;
